"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GAME_ADVERTISEMENT_STATS_FRAGMENT = exports.typeDef = exports.GameStatAdTypes = void 0;
const graphql_tag_1 = __importDefault(require("graphql-tag"));
exports.GameStatAdTypes = ['ingame_banner', 'midroll', 'rewarded'];
exports.typeDef = (0, graphql_tag_1.default) `
  type AdvertisementStats {
    adType: String!
    impressions: Int!
  }

  type GameAdvertisementStats {
    web: [AdvertisementStats!]!
  }
`;
exports.GAME_ADVERTISEMENT_STATS_FRAGMENT = (0, graphql_tag_1.default) `
  fragment AdvertisementStatsFragment on AdvertisementStats {
    adType
    impressions
  }

  fragment GameAdvertisementStatsFragment on GameAdvertisementStats {
    web {
      ...AdvertisementStatsFragment
    }
  }
`;
exports.default = exports.typeDef;
